import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class TablaCamionesEntrePlayaCalado {
  static async getDataCamionesEnTransito () {
    const axios = getAxiosInstance()
    return axios.get(`/consulta_cpa_en_transito_listado?r=` +
    `{"orden": ["d:fecha_de_egreso_playa"]}`).then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }
}

export default TablaCamionesEntrePlayaCalado
